<template>
  <div class="riesgo">
    <div>
      <el-tabs type="border-card">
        <el-tab-pane label="WRAC">
          <br />
          <div style="overflow: auto;">
            <table cellspacing="0" class="wrac">
              <tr>
                <td style="border: 0px;"></td>
                <td style="border: 0px;"></td>
                <td
                  style="padding: 0px; background-color: #07758D; color: white; cursor: pointer; text-align: center; font-size: 12px;"
                  @click="dialogPeligro = true;"
                >Editar</td>
                <td
                  style="padding: 0px; background-color: #07758D; color: white; cursor: pointer; text-align: center; font-size: 12px;"
                  @click="dialogEnergia = true;"
                >Editar</td>
                <td
                  style="padding: 0px; background-color: #07758D; color: white; cursor: pointer; text-align: center; font-size: 12px;"
                  @click="dialogEventoTop = true;"
                >Editar</td>
                <td
                  style="padding: 0px; background-color: #07758D; color: white; cursor: pointer; text-align: center; font-size: 12px;"
                  @click="dialogEventoNoDeseado = true;"
                >Editar</td>
                <td
                  style="padding: 0px; background-color: #07758D; color: white; cursor: pointer; text-align: center; font-size: 12px;"
                  @click="dialogSetProbabilidadSinControles = true;"
                >Editar</td>
                <td
                  style="padding: 0px; background-color: #07758D; color: white; cursor: pointer; text-align: center; font-size: 12px;"
                  @click="dialogSetSeveridadSinControles = true;"
                >Editar</td>
                <td style="border: 0px;"></td>
                <td style="border: 0px;"></td>
                <td style="border: 0px;"></td>
                <td style="border: 0px;"></td>
                <td style="border: 0px;"></td>
                <td style="border: 0px;"></td>
                <td
                  style="padding: 0px; background-color: #07758D; color: white; cursor: pointer; text-align: center; font-size: 12px;"
                  @click="dialogSetProbabilidadConControles = true;"
                >Editar</td>
                <td
                  style="padding: 0px; background-color: #07758D; color: white; cursor: pointer; text-align: center; font-size: 12px;"
                  @click="dialogSetSeveridadConControles = true;"
                >Editar</td>
                <td style="border: 0px;"></td>
                <td colspan="2" style="padding: 0px;">
                  <el-button
                    @click="dialogNewEvaluadorVisible = true;"
                    size="small"
                    style="border-radius: 0px;"
                    icon="el-icon-plus"
                    class="full-width"
                    type="primary"
                  >Agregar Nuevo Responsable</el-button>
                </td>
                <td
                  style="padding: 0px; background-color: #07758D; color: white; cursor: pointer; text-align: center; font-size: 12px;"
                  @click="dialogControlesAdicionales = true;"
                >Editar</td>
                <td
                  style="padding: 0px; background-color: #07758D; color: white; cursor: pointer; text-align: center; font-size: 12px;"
                  @click="dialogResponsable = true;"
                >Editar</td>
                <td
                  style="padding: 0px; background-color: #07758D; color: white; cursor: pointer; text-align: center; font-size: 12px;"
                  @click="dialogFecha = true;"
                >Editar</td>
              </tr>
              <tr style="text-align: center;">
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                  rowspan="2"
                >N°</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                  rowspan="2"
                >Paso del Proceso</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                  rowspan="2"
                >Peligro</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                  rowspan="2"
                >Energía</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                  rowspan="2"
                >Evento Top</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                  rowspan="2"
                >Evento(s) no deseado(s)</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                  colspan="3"
                >Clasificación del Riesgo Sin Control</td>
                <td style="padding: 0px;" colspan="5">
                  <el-button
                    @click="dialogTypeControl = true;"
                    size="small"
                    style="border-radius: 0px;"
                    icon="el-icon-plus"
                    class="full-width"
                    type="primary"
                  >Agregar Nuevo Control</el-button>
                </td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                  colspan="3"
                >Clasificación del Riesgo Sin Control</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                  colspan="2"
                >Gestión Sobre el control</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                  colspan="3"
                >Administración</td>
              </tr>
              <tr style="text-align: center;">
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                >Probabilidad</td>
                <td style="padding: 5px; background-color: rgb(0, 153, 153); color: white;">Severidad</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                >Clasificación del Riesgo Puro</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white; cursor: pointer;"
                >Controles existentes</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                >Jerarquía de Control</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                >Crítico o No Crítico</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                >Preventivo o Mitigador</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                >Elemento de soporte al control</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                >Probabilidad</td>
                <td style="padding: 5px; background-color: rgb(0, 153, 153); color: white;">Severidad</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                >Clasificación del Riesgo Residual</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                >Responsables de Verificar los Controles(Cargo)</td>
                <td style="padding: 5px; background-color: rgb(0, 153, 153); color: white;">Frecuencia</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                >Controles Adicionales (a implementar)</td>
                <td
                  style="padding: 5px; background-color: rgb(0, 153, 153); color: white;"
                >Responsable (Cargo)</td>
                <td style="padding: 5px; background-color: rgb(0, 153, 153); color: white;">Fecha</td>
              </tr>
              <tr>
                <td style="padding: 5px;">
                  <center>1</center>
                </td>
                <td style="padding: 5px;">{{taskName}}</td>
                <td style="padding: 5px;">
                  <div style="width: 90px; word-wrap: break-word; overflow: auto;">{{risk.peligro}}</div>
                </td>
                <td style="padding: 5px;">
                  <div style="width: 90px; word-wrap: break-word; overflow: auto;">{{risk.energia}}</div>
                </td>
                <td style="padding: 5px;">
                  <div style="width: 70px; word-wrap: break-word; overflow: auto;">{{risk.nombre}}</div>
                </td>
                <td style="padding: 5px;">
                  <div
                    style="width: 70px; word-wrap: break-word; overflow: auto;"
                  >{{risk.evento_no_deseado}}</div>
                </td>
                <td style="padding: 5px;">
                  <center>{{risk.sin_controles ? risk.sin_controles.probabilidad : 0}}</center>
                </td>
                <td style="padding: 5px;">
                  <center>{{risk.sin_controles ? risk.sin_controles.severidad : 0}}</center>
                </td>
                <td
                  style="padding: 5px;"
                  :class="`${risk.sin_controles ? getColors(risk.sin_controles.probabilidad, risk.sin_controles.severidad) : ''}`"
                >
                  <center>{{risk.sin_controles ? (risk.sin_controles.severidad * risk.sin_controles.probabilidad) : 0}}</center>
                </td>

                <td>
                  <div
                    style="border: 1px solid black; padding: 5px; height: 90px; width: 90px; word-wrap: break-word; overflow: auto;"
                    v-for="(item, index) in getControlesPreventivos(risk).concat(getControlesMitigadores(risk))"
                    :key="index"
                  >{{item.nombre}}</div>
                </td>
                <td>
                  <div
                    style="border: 1px solid black; padding: 5px; height: 90px; word-wrap: break-word; overflow: auto;"
                    v-for="(item, index) in getControlesPreventivos(risk).concat(getControlesMitigadores(risk))"
                    :key="index"
                  >
                    <center>{{item.jerarquiaControl}}</center>
                  </div>
                </td>
                <td>
                  <div
                    style="border: 1px solid black; padding: 5px; height: 90px; word-wrap: break-word; overflow: auto;"
                    v-for="(item, index) in getControlesPreventivos(risk).concat(getControlesMitigadores(risk))"
                    :key="index"
                  >
                    <center>{{item.critico === true ? "SI" : "NO"}}</center>
                  </div>
                </td>
                <td>
                  <div
                    style="border: 1px solid black; padding: 5px; height: 90px; word-wrap: break-word; overflow: auto;"
                    v-for="(item, index) in getControlesPreventivos(risk).concat(getControlesMitigadores(risk))"
                    :key="index"
                  >
                    <center>{{item.tipo}}</center>
                  </div>
                </td>
                <td>
                  <div
                    style="border: 1px solid black; padding: 5px; height: 90px; word-wrap: break-word; overflow: auto;"
                    v-for="(item, index) in getControlesPreventivos(risk).concat(getControlesMitigadores(risk))"
                    :key="index"
                  >{{item.elemento_soporte}}</div>
                </td>

                <td style="padding: 5px;">
                  <center>{{risk.con_controles ? risk.con_controles.probabilidad : 0}}</center>
                </td>
                <td style="padding: 5px;">
                  <center>{{risk.con_controles ? risk.con_controles.severidad : 0}}</center>
                </td>
                <td
                  style="padding: 5px;"
                  :class="`${risk.con_controles ? getColors(risk.con_controles.probabilidad, risk.con_controles.severidad) : ''}`"
                >
                  <center>{{risk.con_controles ? (risk.con_controles.severidad * risk.con_controles.probabilidad) : 0}}</center>
                </td>
                <td>
                  <div
                    style="border: 1px solid black; padding: 5px; height: 90px; word-wrap: break-word; overflow: auto;"
                    v-for="(item, index) in risk.evaluadores"
                    :key="index"
                  >
                    <center>{{item.cargo}}</center>
                  </div>
                </td>
                <td>
                  <div
                    style="border: 1px solid black; padding: 5px; height: 90px; width: 90px; word-wrap: break-word; overflow: auto;"
                    v-for="(item, index) in risk.evaluadores"
                    :key="index"
                  >
                    <center>{{item.frecuencia}}</center>
                  </div>
                </td>
                <td style="padding: 5px;">
                  <div
                    style="width: 90px; word-wrap: break-word; overflow: auto;"
                  >{{risk.control_adicional}}</div>
                </td>
                <td style="padding: 5px;">
                  <div
                    style="width: 90px; word-wrap: break-word; overflow: auto;"
                  >{{risk.responsable}}</div>
                </td>
                <td style="padding: 5px;">
                  <div style="width: 40px; word-wrap: break-word; overflow: auto;">{{risk.fecha}}</div>
                </td>
              </tr>
            </table>
          </div>
          <br />

          <!-- PELIGRO DIALOG -->
          <el-dialog
            append-to-body
            title="Peligro"
            :visible.sync="dialogPeligro"
            width="30%"
            :before-close="closeDialogWrac"
          >
            <br />Ingrese Peligro
            <el-input style="margin-top: 8px;" size="small" v-model="risk.peligro"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="closeDialogWrac">Cerrar</el-button>
            </span>
          </el-dialog>

          <!-- ENERGIA DIALOG -->
          <el-dialog
            append-to-body
            title="Energía"
            :visible.sync="dialogEnergia"
            width="30%"
            :before-close="closeDialogWrac"
          >
            <br />Ingrese Energía
            <el-input style="margin-top: 8px;" size="small" v-model="risk.energia"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="closeDialogWrac">Cerrar</el-button>
            </span>
          </el-dialog>

          <!-- EVENTO TOP DIALOG -->
          <el-dialog
            append-to-body
            title="Evento Top"
            :visible.sync="dialogEventoTop"
            width="30%"
            :before-close="closeDialogWrac"
          >
            <br />Ingrese Evento Top
            <el-input style="margin-top: 8px;" size="small" v-model="risk.nombre"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="closeDialogWrac">Cerrar</el-button>
            </span>
          </el-dialog>

          <!-- EVENTO NO DESEADO DIALOG -->
          <el-dialog
            append-to-body
            title="Evento No Deseado"
            :visible.sync="dialogEventoNoDeseado"
            width="30%"
            :before-close="closeDialogWrac"
          >
            <br />Ingrese Evento No Deseado
            <el-input style="margin-top: 8px;" size="small" v-model="risk.evento_no_deseado"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="closeDialogWrac">Cerrar</el-button>
            </span>
          </el-dialog>

          <!-- CONTROLES ADICIONALES DIALOG -->
          <el-dialog
            append-to-body
            title="Controles Adicionales (a implementar)"
            :visible.sync="dialogControlesAdicionales"
            width="30%"
            :before-close="closeDialogWrac"
          >
            <br />Controles Adicionales (a implementar)
            <el-input style="margin-top: 8px;" size="small" v-model="risk.control_adicional"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="closeDialogWrac">Cerrar</el-button>
            </span>
          </el-dialog>

          <!-- RESPONSABLE CARGO -->
          <el-dialog
            append-to-body
            title="Responsable (Cargo)"
            :visible.sync="dialogResponsable"
            width="30%"
            :before-close="closeDialogWrac"
          >
            <br />Responsable (Cargo)
            <el-input style="margin-top: 8px;" size="small" v-model="risk.responsable"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="closeDialogWrac">Cerrar</el-button>
            </span>
          </el-dialog>

          <!-- FECHA -->
          <el-dialog
            append-to-body
            title="Fecha"
            :visible.sync="dialogFecha"
            width="30%"
            :before-close="closeDialogWrac"
          >
            <br />Fecha
            <el-input type="date" style="margin-top: 8px;" size="medium" v-model="risk.fecha"></el-input>
            <span slot="footer" class="dialog-footer">
              <el-button type="primary" @click="closeDialogWrac">Cerrar</el-button>
            </span>
          </el-dialog>

          <!-- SELECCIÓN TIPO CONTROL -->
          <el-dialog
            width="700px"
            title="Seleccione tipo de control"
            :visible.sync="dialogTypeControl"
            append-to-body
          >
            <br />
            <center>
              <el-button
                type="primary"
                style="width: 200px;"
                @click="dialogNewControlPreventivoVisible = true"
              >Control Preventivo</el-button>
              <el-button
                type="primary"
                style="width: 200px;"
                @click="dialogNewControlMitigadorVisible = true"
              >Control Mitigador</el-button>
              <el-button
                type="danger"
                style="width: 200px;"
                @click="dialogTypeControl = false"
              >Cancelar</el-button>
            </center>
          </el-dialog>
        </el-tab-pane>
        <el-tab-pane label="BOWTIE">
          <div>
            <h4>{{ $t('DATOS DEL RIESGO') }}</h4>
            <el-form @keydown.native.enter.prevent>
              <el-row :gutter="20">
                <el-col :span="14">
                  <el-form-item :label="$t('Nombre del Riesgo o Aspecto ambiental')">
                    <el-input v-model="risk.nombre" placeholder="Nombre del riesgo" />
                  </el-form-item>
                </el-col>
                <el-col :span="10">
                  <el-form-item :label="$t('Tipo de Impacto')">
                    <br />
                    <el-button-group>
                      <el-button
                        type="info"
                        :plain="risk.tipo && risk.tipo.toLowerCase() !== 'seguridad'"
                        @click="setTypeRisk('seguridad')"
                      >
                        <b>Seguridad</b>
                      </el-button>
                    </el-button-group>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
          <div>
            <hr class="separacion" v-if="risk.tipo && risk.tipo.toLowerCase() === 'medioambiente'" />
            <div v-if="risk.tipo && risk.tipo.toLowerCase() === 'medioambiente'">
              <h4>{{$t('INFORMACIÓN MEDIOAMBIENTAL')}}</h4>
              <el-form>
                <el-row :gutter="20">
                  <el-col :md="12">
                    <el-form-item :label="$t('Responsable')">
                      <el-input
                        v-model="risk.medioambiente.responsable"
                        :placeholder="$t('Ingrese responsable')"
                        v-if="editable"
                      />
                      <div v-else>{{ risk.medioambiente.responsable }}</div>
                    </el-form-item>
                    <el-form-item :label="$t('Condición')">
                      <el-select
                        v-model="risk.medioambiente.condicion"
                        v-if="editable"
                        :placeholder="$t('Seleccione condicion')"
                        class="full-width"
                      >
                        <el-option
                          v-for="item in optionsCondicion"
                          :key="item.value"
                          :label="item.value"
                          :value="item.value"
                        />
                      </el-select>
                      <div v-else>{{ risk.medioambiente.condicion }}</div>
                    </el-form-item>
                  </el-col>
                  <el-col :md="12">
                    <el-form-item :label="$t('Evento')">
                      <el-input
                        v-model="risk.medioambiente.evento"
                        :placeholder="$t('Ingrese evento')"
                        v-if="editable"
                      />
                      <div v-else>{{ risk.medioambiente.evento || 'N/A' }}</div>
                    </el-form-item>
                    <el-form-item :label="$t('Equipo Crítico')">
                      <el-input
                        v-model="risk.medioambiente.equipo"
                        :placeholder="$t('Ingrese equipo')"
                        v-if="editable"
                      />
                      <div v-else>{{ risk.medioambiente.equipo || 'N/A' }}</div>
                    </el-form-item>
                    <el-form-item v-if="!editable" :label="$t('Evaluación Aspecto Ambiental')">
                      <el-tag :type="getFactores(risk)[0].mfl >= 3 ? 'danger' : 'success'">
                        {{ getFactores(risk)[0].mfl >= 3
                        ? $t('Significativo')
                        : $t('No Significativo') }}
                      </el-tag>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form>
            </div>
            <hr class="separacion" />
            <div>
              <el-row :gutter="30">
                <el-col :md="8">
                  <br />
                  <h4 class="margin-title">
                    {{$t('PELIGRO')}}
                    <el-popover
                      class="help-box"
                      placement="top"
                      :title="$t('Escenario')"
                      width="200"
                      trigger="hover"
                      :content="$t(`En construcción.`)"
                    >
                      <i slot="reference" class="el-icon-question"></i>
                    </el-popover>
                  </h4>
                  <el-input
                    v-model="risk.peligro"
                    v-if="editable"
                    type="textarea"
                    :rows="6"
                    :placeholder="$t('Ingrese peligro')"
                  />
                  <p v-else>{{ risk.escenario_residual || $t('No ingresado')}}</p>
                  <br />
                  <br />
                </el-col>
                <el-col :md="8">
                  <br />
                  <h4 class="margin-title">
                    {{$t('ENERGÍA')}}
                    <el-popover
                      class="help-box"
                      placement="top"
                      :title="$t('Escenario MFL')"
                      width="200"
                      trigger="hover"
                      :content="$t(`En construcción.`)"
                    >
                      <i slot="reference" class="el-icon-question"></i>
                    </el-popover>
                  </h4>
                  <el-input
                    v-model="risk.energia"
                    v-if="editable"
                    type="textarea"
                    :rows="6"
                    :placeholder="$t('Ingrese energía')"
                  />
                  <p v-else>{{ risk.escenario_mfl || $t('No ingresado')}}</p>
                  <br />
                  <br />
                </el-col>
                <el-col :md="8">
                  <br />
                  <h4 class="margin-title">
                    {{$t('EVENTO NO DESEADO')}}
                    <el-popover
                      class="help-box"
                      placement="top"
                      :title="$t('Evento no deseado')"
                      width="200"
                      trigger="hover"
                      :content="$t(`En construcción.`)"
                    >
                      <i slot="reference" class="el-icon-question"></i>
                    </el-popover>
                  </h4>
                  <el-input
                    v-model="risk.evento_no_deseado"
                    v-if="editable"
                    type="textarea"
                    :rows="6"
                    :placeholder="$t('Ingrese evento no deseado')"
                  />
                  <p v-else>{{ risk.evento_no_deseado || $t('No ingresado')}}</p>
                  <br />
                  <br />
                </el-col>
                <el-col :md="10">
                  <br />
                  <h4
                    class="left margin-title"
                  >{{ $t('PERSONAS QUE PARTICIPAN EN EL ANÁLISIS DEL RIESGO') }}</h4>
                  <el-button
                    v-if="editable"
                    type="primary"
                    icon="el-icon-plus"
                    class="right button-add"
                    size="mini"
                    @click="dialogNewEvaluadorVisible = true"
                  >
                    <b>{{ $t('Añadir Participante') }}</b>
                  </el-button>
                  <el-table
                    :data="risk.evaluadores"
                    :key="componentKey"
                    row-class-name="rowClassTablaPloma"
                    header-cell-class-name="header-cell-class-table-gray-2"
                  >
                    <el-table-column :label="$t('Nombre')" prop="nombre"></el-table-column>
                    <el-table-column :label="$t('RUT')" prop="rut"></el-table-column>
                    <el-table-column :label="$t('Cargo')" prop="cargo" />
                    <el-table-column
                      v-if="editable"
                      align="center"
                      header-align="center"
                      width="125"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          @click="editDialogEvaluador(scope.row)"
                          icon="el-icon-edit"
                        />
                        <el-button
                          type="danger"
                          size="small"
                          @click="deleteEvaluador(scope.row)"
                          icon="el-icon-delete"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                  <br />
                </el-col>
                <el-col :md="4">
                  <br />
                  <center>
                    <h4 class="align-center">{{$t('IR SIN CONTROLES')}}</h4>
                    <span style="font-size: 27px;">
                      <b>{{risk.sin_controles ? (risk.sin_controles.severidad * risk.sin_controles.probabilidad) : 0}}</b>
                    </span>
                  </center>
                </el-col>
                <el-col :md="10">
                  <br />
                  <h4 class="margin-title">{{ $t('SIN CONTROLES') }}</h4>
                  <el-form label-position="top" :inline="true">
                    <el-form-item label="Ingrese severidad">
                      <center>
                        <el-button
                          type="primary"
                          size="medium"
                          @click="dialogSetSeveridadSinControles = true;"
                        >Seleccione Nivel de Severidad</el-button>
                        <br />
                        <span style="font-size: 27px;">
                          <b>{{risk.sin_controles ? risk.sin_controles.severidad : 0}}</b>
                        </span>
                      </center>
                    </el-form-item>
                    <el-form-item label="Ingrese probabilidad">
                      <center>
                        <el-button
                          type="primary"
                          size="medium"
                          @click="dialogSetProbabilidadSinControles = true;"
                        >Seleccione Nivel de Probabilidad</el-button>
                        <br />
                        <span style="font-size: 27px;">
                          <b>{{risk.sin_controles ? risk.sin_controles.probabilidad : 0}}</b>
                        </span>
                      </center>
                    </el-form-item>
                    <el-form-item label="Indice de riesgo">
                      <center>
                        <el-button type="primary" size="medium">S x P</el-button>
                        <br />
                        <span style="font-size: 27px;">
                          <b>{{risk.sin_controles ? (risk.sin_controles.severidad * risk.sin_controles.probabilidad) : 0}}</b>
                        </span>
                      </center>
                    </el-form-item>
                  </el-form>
                </el-col>
              </el-row>
            </div>
            <hr class="separacion" />
            <div class="box-card">
              <el-row :gutter="20">
                <!-- Causas -->
                <el-col :md="10">
                  <br />
                  <h4 class="left margin-title">
                    {{$t('CAUSAS')}}
                    <el-popover
                      class="help-box"
                      placement="top"
                      :title="$t('Causas')"
                      width="200"
                      trigger="hover"
                      :content="$t('Las causas son las circunstancias que pueden gatillar la ocurrencia del evento.')"
                    >
                      <i slot="reference" class="el-icon-question" />
                    </el-popover>
                  </h4>
                  <el-button
                    v-if="editable"
                    icon="el-icon-plus"
                    type="primary"
                    size="mini"
                    class="right button-add"
                    @click="dialogNewCausaVisible = true"
                  >
                    <b>{{ $t('Añadir Causa') }}</b>
                  </el-button>
                  <el-table
                    :data="risk.causas"
                    style="width: 100%"
                    :key="componentKey"
                    row-class-name="rowClassTablaPloma"
                    header-cell-class-name="header-cell-class-table-gray-2"
                  >
                    <el-table-column prop="id" label="ID" width="80">
                      <template slot-scope="scope">CA{{ risk.causas.indexOf(scope.row) + 1 }}</template>
                    </el-table-column>
                    <el-table-column prop="nombre" :label="$t('Nombre')" />
                    <el-table-column
                      v-if="editable"
                      align="center"
                      header-align="center"
                      width="125"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          @click="editDialogCausa(scope.row)"
                          icon="el-icon-edit"
                        />
                        <el-button
                          type="danger"
                          size="small"
                          @click="deleteCausa(scope.row)"
                          icon="el-icon-delete"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                  <br />
                </el-col>
                <!-- Riesgo -->
                <el-col :md="4">
                  <!-- COLORES
              Material rojo
              No material amarillo
                  Custom celeste-->
                  <!-- Riesgo Material creado por MEL desde admin -->
                  <div
                    v-if="risk.tipo && risk.tipo.toLowerCase() === 'salud'"
                    class="colorSalud customRiskBox"
                  >{{ risk.nombre === '' ? 'Sin nombre': risk.nombre }}</div>
                  <!-- Riesgo No Material creado por MEL desde admin -->
                  <div
                    v-if="risk.tipo && risk.tipo.toLowerCase() === 'seguridad'"
                    class="colorSeguridad customRiskBox"
                  >{{ risk.nombre === '' ? 'Sin nombre': risk.nombre }}</div>
                  <!-- Riesgo Personalizado -->
                  <div
                    v-if="risk.tipo && (risk.tipo.toLowerCase() === 'medioambiental' || risk.tipo.toLowerCase() === 'medioambiente')"
                    class="colorMedioambiental customRiskBox"
                  >{{ risk.nombre === '' ? 'Sin nombre': risk.nombre }}</div>
                  <!-- Riesgo Sin tipo -->
                  <div
                    v-if="risk.tipo === null"
                    class="colorWithoutRisk customRiskBox"
                  >{{ risk.nombre === '' ? 'Sin nombre': risk.nombre }}</div>
                </el-col>
                <!-- Impactos -->
                <el-col :md="10">
                  <br />
                  <h4 class="left margin-title">
                    {{$t('IMPACTOS')}}
                    <el-popover
                      class="help-box"
                      placement="top"
                      :title="$t('Impactos')"
                      width="200"
                      trigger="hover"
                      :content="$t(`Nivel de severidad cuando el evento ocurre.`)"
                    >
                      <i slot="reference" class="el-icon-question" />
                    </el-popover>
                  </h4>
                  <el-button
                    v-if="editable"
                    icon="el-icon-plus"
                    size="mini"
                    type="primary"
                    class="right button-add"
                    :class="!risk.tipo && 'button-disabled'"
                    :disabled="!risk.tipo"
                    @click="dialogNewImpactoVisible = true"
                  >
                    <b>{{ $t('Agregar Impacto') }}</b>
                  </el-button>
                  <el-table
                    :data="risk.impactos"
                    style="width: 100%"
                    row-class-name="rowClassTablaPloma"
                    header-cell-class-name="header-cell-class-table-gray-2"
                  >
                    <el-table-column prop="id" label="ID" width="80">
                      <template slot-scope="scope">IM{{ risk.impactos.indexOf(scope.row) + 1 }}</template>
                    </el-table-column>
                    <el-table-column prop="tipo" :label="$t('Tipo')" />
                    <el-table-column :label="$t('Descripción')">
                      <template
                        slot-scope="scope"
                      >{{ scope.row.descripcion.substring(0, 80) || "" }} [...]</template>
                    </el-table-column>
                    <el-table-column prop="mfl" label="MFL" width="50" />
                    <el-table-column
                      v-if="editable"
                      align="center"
                      header-align="center"
                      width="125"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          icon="el-icon-edit"
                          @click="editDialogImpacto(scope.row)"
                        />
                        <el-button
                          type="danger"
                          size="small"
                          icon="el-icon-delete"
                          @click="deleteImpacto(scope.row)"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                  <br />
                </el-col>
              </el-row>
            </div>
            <div>
              <el-row :gutter="20">
                <!-- Controles Preventivos -->
                <el-col :md="10">
                  <hr />
                  <br />
                  <h4 class="left margin-title">
                    {{ $t('CONTROLES PREVENTIVOS') }}
                    <el-popover
                      class="help-box"
                      placement="top"
                      :title="$t('Controles Preventivos')"
                      width="200"
                      trigger="hover"
                      :content="$t(`Los controles preventivos son los que se
                    utilizan para enfrentarse a las causas, por lo que reducen
                    la probabilidad de que ocurran riesgos.`)"
                    >
                      <i slot="reference" class="el-icon-question" />
                    </el-popover>
                  </h4>
                  <el-button
                    v-if="editable && risk.causas.length > 0"
                    icon="el-icon-plus"
                    class="right button-add"
                    type="primary"
                    size="mini"
                    @click="dialogNewControlPreventivoVisible = true"
                  >
                    <b>{{ $t('Añadir Control Preventivo') }}</b>
                  </el-button>
                  <el-table
                    row-class-name="rowClassTablaPloma"
                    header-cell-class-name="header-cell-class-table-gray-2"
                    :key="componentKey"
                    :data="getControlesPreventivos(risk)"
                    style="width: 100%"
                  >
                    <el-table-column prop="nombre" :label="$t('Nombre')" />
                    <el-table-column prop="id_causa" :label="$t('Causa')" width="90">
                      <template slot-scope="scope">
                        <div
                          v-for="causaHumanID in scope.row.causasHumanID"
                          :key="causaHumanID"
                        >{{ causaHumanID }}</div>
                      </template>
                    </el-table-column>
                    <el-table-column
                      v-if="editable"
                      align="center"
                      header-align="center"
                      width="125"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          @click="editDialogControlPreventivo(scope.row)"
                          icon="el-icon-edit"
                        />
                        <el-button
                          type="danger"
                          size="small"
                          @click="deleteControlPreventivo(scope.row)"
                          icon="el-icon-delete"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
                <!-- Factores -->
                <el-col :md="4">
                  <br />
                  <br />
                  <br />
                  <center>
                    <h4 class="align-center">{{$t('IR CON CONTROLES')}}</h4>
                    <span style="font-size: 27px;">
                      <b>{{risk.con_controles ? (risk.con_controles.severidad * risk.con_controles.probabilidad) : 0}}</b>
                    </span>
                  </center>
                </el-col>
                <!-- Controles Mitigadores -->
                <el-col :md="10">
                  <hr />
                  <br />
                  <h4 class="left margin-title">
                    {{$t('CONTROLES MITIGADORES')}}
                    <el-popover
                      class="help-box"
                      placement="top"
                      title="Controles Mitigadores"
                      width="200"
                      trigger="hover"
                      :content="$t(`Los controles de mitigación son aquellos que
                    reducen los impactos derivados de un riesgo.`)"
                    >
                      <i slot="reference" class="el-icon-question" />
                    </el-popover>
                  </h4>
                  <el-button
                    v-if="editable && risk.impactos.length > 0 && validarControlMitigador(risk.impactos)"
                    icon="el-icon-d-arrow-right"
                    class="right button-skip"
                    type="primary"
                    size="mini"
                    @click="skipControlMitigador(risk.impactos)"
                  >
                    <b>{{ $t('No Aplica') }}</b>
                  </el-button>
                  <el-button
                    v-if="editable && risk.impactos.length > 0 && validarControlMitigador(risk.impactos)"
                    icon="el-icon-plus"
                    class="right button-add"
                    type="primary"
                    size="mini"
                    @click="openDialogControlMitigador()"
                  >
                    <b>{{ $t('Añadir Control Mitigador') }}</b>
                  </el-button>
                  <el-table
                    row-class-name="rowClassTablaPloma"
                    header-cell-class-name="header-cell-class-table-gray-2"
                    :data="getControlesMitigadores(risk)"
                    style="width: 100%"
                  >
                    <el-table-column prop="nombre" :label="$t('Nombre')" />
                    <el-table-column prop="id_impacto" :label="$t('Impacto')" width="90" />
                    <el-table-column
                      v-if="editable"
                      align="center"
                      header-align="center"
                      width="125"
                    >
                      <template slot-scope="scope">
                        <el-button
                          v-if="scope.row.not_apply === false || scope.row.hasOwnProperty('not_apply') === false"
                          size="small"
                          @click="editDialogControlMitigador(scope.row)"
                          icon="el-icon-edit"
                        />
                        <el-button
                          type="danger"
                          size="small"
                          @click="deleteControlMitigador(scope.row)"
                          icon="el-icon-delete"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
              </el-row>
              <el-row>
                <el-col :md="10">
                  <br />
                  <br />
                  <h4 class="margin-title">
                    {{$t('CONTROL ADICIONAL')}}
                    <el-popover
                      class="help-box"
                      placement="top"
                      :title="$t('Control adicional')"
                      width="200"
                      trigger="hover"
                      :content="$t(`En construcción.`)"
                    >
                      <i slot="reference" class="el-icon-question"></i>
                    </el-popover>
                  </h4>
                  <el-input
                    v-model="risk.control_adicional"
                    v-if="editable"
                    type="textarea"
                    :rows="3"
                    :placeholder="$t('Ingrese control adicional')"
                  />
                  <p v-else>{{ risk.evento_no_deseado || $t('No ingresado')}}</p>
                  <br />
                  <br />
                </el-col>
                <el-col :md="10" :offset="4">
                  <br />
                  <br />
                  <h4 class="margin-title">{{ $t('CON CONTROLES') }}</h4>
                  <el-form label-position="top" :inline="true">
                    <el-form-item label="Ingrese severidad">
                      <center>
                        <el-button
                          type="primary"
                          size="medium"
                          @click="dialogSetSeveridadConControles = true;"
                        >Seleccione Nivel de Severidad</el-button>
                        <br />
                        <span style="font-size: 27px;">
                          <b>{{risk.con_controles ? risk.con_controles.severidad : 0}}</b>
                        </span>
                      </center>
                    </el-form-item>
                    <el-form-item label="Ingrese probabilidad">
                      <center>
                        <el-button
                          type="primary"
                          size="medium"
                          @click="dialogSetProbabilidadConControles = true;"
                        >Seleccione Nivel de Probabilidad</el-button>
                        <br />
                        <span style="font-size: 27px;">
                          <b>{{risk.con_controles ? risk.con_controles.probabilidad : 0}}</b>
                        </span>
                      </center>
                    </el-form-item>
                    <el-form-item label="Indice de riesgo">
                      <center>
                        <el-button type="primary" size="medium">S x P</el-button>
                        <br />
                        <span style="font-size: 27px;">
                          <b>{{risk.con_controles ? (risk.con_controles.severidad * risk.con_controles.probabilidad) : 0}}</b>
                        </span>
                      </center>
                    </el-form-item>
                  </el-form>
                </el-col>
                <el-col :md="10">
                  <br />
                  <h4
                    class="margin-title"
                  >{{$t('JUSTIFICACIÓN EVALUACIÓN (CRITERIOS Y COMENTARIOS)')}}</h4>
                  <el-input
                    v-model="risk.justificacion_evaluacion"
                    v-if="editable"
                    type="textarea"
                    :rows="3"
                    :placeholder="$t('Ingrese Justificación Evaluación (Criterios y comentarios)')"
                  />
                  <p v-else>{{ risk.justificacion_evaluacion || $t('No ingresado')}}</p>
                  <br />
                  <br />
                </el-col>
                <el-col :md="10" :offset="4">
                  <br />
                  <el-button
                    v-if="editable"
                    icon="el-icon-plus"
                    class="right button-add"
                    type="primary"
                    size="mini"
                    @click="openDialogKRI()"
                  >
                    <b>{{ $t('Añadir KRI Establecidos') }}</b>
                  </el-button>
                  <h4 class="margin-title">{{$t('KRI ESTABLECIDOS')}}</h4>
                  <el-table
                    :key="componentKey"
                    row-class-name="rowClassTablaPloma"
                    header-cell-class-name="header-cell-class-table-gray-2"
                    :data="risk.kri"
                    style="width: 100%"
                  >
                    <el-table-column prop="descripcion" :label="$t('Descripción del KRI')" />
                    <el-table-column prop="valor" :label="$t('Valor')" width="90" />
                    <el-table-column
                      v-if="editable"
                      align="center"
                      header-align="center"
                      width="125"
                    >
                      <template slot-scope="scope">
                        <el-button
                          size="small"
                          @click="editDialogKRI(scope.row)"
                          icon="el-icon-edit"
                        />
                        <el-button
                          type="danger"
                          size="small"
                          @click="deleteDialogKRI(scope.$index)"
                          icon="el-icon-delete"
                        />
                      </template>
                    </el-table-column>
                  </el-table>
                </el-col>
                <el-col :md="10">
                  <br />
                  <h4 class="margin-title">{{$t('CALCULO MFL')}}</h4>
                  <el-input
                    v-model="risk.calculo_mfl"
                    v-if="editable"
                    type="textarea"
                    :rows="3"
                    :placeholder="$t('Ingrese Calculo MFL')"
                  />
                  <p v-else>{{ risk.calculo_mfl || $t('No ingresado')}}</p>
                  <br />
                  <br />
                </el-col>
                <el-col :md="10" :offset="4">
                  <br />
                  <h4 class="margin-title">{{$t('RESPONSABLE (CARGO)')}}</h4>
                  <el-input
                    v-model="risk.responsable"
                    v-if="editable"
                    type="textarea"
                    :rows="3"
                    :placeholder="$t('Ingrese Responsable')"
                  />
                  <p v-else>{{ risk.responsable || $t('No ingresado')}}</p>
                  <br />
                  <br />
                </el-col>
                <el-col :md="10">
                  <br />
                  <h4 class="margin-title">{{$t('FECHA')}}</h4>
                  <el-input
                    v-model="risk.fecha"
                    v-if="editable"
                    type="textarea"
                    :rows="3"
                    :placeholder="$t('Ingrese Fecha')"
                  />
                  <p v-else>{{ risk.fecha || $t('No ingresado')}}</p>
                  <br />
                  <br />
                </el-col>
              </el-row>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <el-dialog
      :before-close="handleClose"
      title="KRI Establecidos"
      width="40%"
      append-to-body
      :visible="dialogAddKRI"
    >
      <el-form :model="kri" label-position="top">
        <el-form-item label="Descripción" :label-width="formLabelWidth">
          <el-input v-model="kri.descripcion" class="with-help-box" />
        </el-form-item>
        <el-form-item label="Valor" :label-width="formLabelWidth">
          <el-input v-model="kri.valor" class="with-help-box" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">{{$t('Cancelar')}}</el-button>
        <el-button type="primary" @click="addKRI">{{ $t('Guardar') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      title="KRI Establecidos"
      width="40%"
      append-to-body
      :visible="dialogEditKRI"
    >
      <el-form :model="kri" label-position="top">
        <el-form-item label="Descripción" :label-width="formLabelWidth">
          <el-input v-model="kri.descripcion" class="with-help-box" />
        </el-form-item>
        <el-form-item label="Valor" :label-width="formLabelWidth">
          <el-input v-model="kri.valor" class="with-help-box" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose()">{{$t('Cancelar')}}</el-button>
        <el-button type="primary" @click="editKRI">{{ $t('Guardar') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      title="Evaluador"
      width="40%"
      append-to-body
      :visible="dialogNewEvaluadorVisible"
    >
      <el-form
        v-loading="searchUser"
        element-loading-text="Buscando Usuario..."
        element-loading-background="rgba(255, 255, 255)"
        :model="formEvaluador"
        label-position="top"
        :rules="rulesEvaluador"
        ref="formEvaluador"
      >
        <el-form-item label="RUT" prop="rut" :label-width="formLabelWidth">
          <el-input v-model="formEvaluador.rut" class="with-help-box" auto-complete="on" />
          <el-popover
            class="help-box"
            placement="right"
            title="RUT"
            width="200"
            trigger="hover"
            :content="$t('Escriba el RUT del evaluador')"
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item label="Nombre" prop="nombre" :label-width="formLabelWidth">
          <el-input
            :disabled="inputNombreDisable === true || !formEvaluador.rut"
            v-model="formEvaluador.nombre"
            class="with-help-box"
            auto-complete="on"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Nombre')"
            width="200"
            trigger="hover"
            :content="$t('Escriba el Nombre del evaluador')"
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item label="Cargo" prop="cargo" :label-width="formLabelWidth">
          <el-input
            :disabled="inputCargoDisable === true || !formEvaluador.rut"
            v-model="formEvaluador.cargo"
            class="with-help-box"
            auto-complete="on"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Cargo')"
            width="200"
            trigger="hover"
            :content="$t('Escriba el Cargo del evaluador al momento de la evaluación')"
          >
            <i slot="reference" class="el-icon-question" />
          </el-popover>
        </el-form-item>
        <el-form-item label="Frecuencia" prop="frecuencia" :label-width="formLabelWidth">
          <el-select
            v-model="formEvaluador.frecuencia"
            filterable
            class="with-help-box full-width"
            :placeholder="$t(`Seleccione una frecuencia`)"
          >
            <el-option
              v-for="item in frecuencias"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogEvaluador()">{{ $t('Cancelar') }}</el-button>
        <el-button
          type="primary"
          @click="editEvaluador('formEvaluador')"
          v-if="editingEvaluador"
        >{{ $t('Guardar') }}</el-button>
        <el-button type="primary" @click="addEvaluador('formEvaluador')" v-else>{{ $t('Agregar') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      title="Causa"
      :rules="rules"
      append-to-body
      ref="formCausa"
      :visible="dialogNewCausaVisible"
    >
      <p>
        {{ $t(`A continuación se presenta un listado con causas predefenidas.
        En el caso que una causa del evento no se encuentre en listado,
        seleccionar la opción \'Otro\' al final del listado y agregarla en
        el recuadro de texto que se desplegara.`) }}
      </p>
      <el-select
        v-model="formCausa.nombreTemp"
        :placeholder="$t('Seleccione causa asociada')"
        class="with-help-box full-width"
      >
        <el-option-group v-for="group in causasInmediatasComputed" :key="group.label">
          <p class="groupLabel">{{group.label}}</p>
          <el-option
            v-for="item in group.options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-option-group>
      </el-select>
      <br />
      <br />
      <div v-if="formCausa.nombreTemp === 'other'">
        <el-input
          v-model="formCausa.nombre"
          class="with-help-box full-width"
          :placeholder="$t('Escriba causa del evento')"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogCausa()">{{$t('Cancelar')}}</el-button>
        <el-button
          v-if="editingCausa"
          type="primary"
          @click="editCausa('formCausa')"
        >{{ $t('Guardar') }}</el-button>
        <el-button v-else type="primary" @click="addCausa('formCausa')">{{ $t('Agregar') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Control Preventivo')"
      append-to-body
      :rules="rules"
      ref="formControlPreventivo"
      :visible="dialogNewControlPreventivoVisible"
    >
      <el-form :model="formControlPreventivo" label-position="top">
        <el-form-item
          :label="$t('Causas asociadas al control preventivo')"
          prop="causa"
          :label-width="formLabelWidth"
        >
          <el-select
            style="float: left; width: 750px;"
            v-model="formControlPreventivo.causas"
            multiple
            filterable
            class="with-help-box"
            :placeholder="$t('Seleccione causas asociada')"
          >
            <el-option
              v-for="causa in risk.causas"
              :key="causa.id"
              :label="causa.nombre"
              :value="causa.id"
            />
          </el-select>
          <el-button
            @click="dialogNewCausaVisible = true"
            style="margin-left: 10px;"
            type="primary"
            size="medium"
          >Añadir Causa</el-button>
        </el-form-item>
        <el-form-item
          :label="$t('Nombre del control preventivo')"
          prop="nombre"
          :label-width="formLabelWidth"
        >
          <el-input
            class="with-help-box"
            v-model="formControlPreventivo.nombre"
            auto-complete="on"
          />
        </el-form-item>
        <el-form-item
          :label="$t('Responsable del control preventivo')"
          :label-width="formLabelWidth"
        >
          <el-input
            class="with-help-box"
            v-model="formControlPreventivo.responsable"
            auto-complete="on"
          />
        </el-form-item>
        <el-form-item :label="$t(`Frecuencia`)" :label-width="formLabelWidth">
          <el-select
            v-model="formControlPreventivo.frecuencia"
            filterable
            class="with-help-box full-width"
            :placeholder="$t(`Seleccione una frecuencia`)"
          >
            <el-option
              v-for="item in frecuencias"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t(`Jerarquía de control`)"
          prop="jerarquia"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="formControlPreventivo.jerarquiaControl"
            filterable
            class="with-help-box full-width"
            :placeholder="$t(`Seleccione Jerarquía de control`)"
          >
            <el-option
              v-for="jerarquia in jerarquiaControl"
              :key="jerarquia.value"
              :label="jerarquia.value"
              :value="jerarquia.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t(`Elemento de soporte al control`)"
          prop="elemento_soporte"
          :label-width="formLabelWidth"
        >
          <el-input
            class="with-help-box"
            v-model="formControlPreventivo.elemento_soporte"
            :placeholder="$t(`Seleccione Elemento de soporte al control`)"
          />
        </el-form-item>
        <el-form-item
          :label="$t('¿Es control crítico?')"
          prop="critico"
          :label-width="formLabelWidth"
        >
          <el-switch
            class="with-help-box"
            v-model="formControlPreventivo.critico"
            active-text="Sí"
            inactive-text="No"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Control Crítico')"
            width="400"
            trigger="hover"
          >
            {{ $t(`Son quellos controles que solo o en conjunto con otros
            controles reduce significativamente la probabilidad
            y/o el impacto de los riesgos materiales.`) }}
            <br />
            {{ $t(`Puede haber más de un control crítico para un riesgo material.`) }}
            <br />
            {{ $t(`Elementos a considerar en la determinación de un control crítico:`) }}
            <ul>
              <li>
                {{ $t(`Única barrera/capa de protección disponible para la ocurrencia
                del evento o la exposición al impacto.`) }}
              </li>
              <li>{{ $t(`Se utiliza para prevenir o mitigar múltiples causas/impactos.`) }}</li>
              <li>{{ $t(`Es independiente de otros controles.`) }}</li>
              <li>
                {{ $t(`El control es más alto en la jerarquía de controles que
                otros controles en consideración.`) }}
              </li>
              <li>{{ $t(`Se utiliza para detectar o prevenir que el evento escale.`) }}</li>
            </ul>
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogControlPreventivo()">{{$t('Cancelar')}}</el-button>
        <el-button
          type="primary"
          @click="editControlPreventivo('formControlPreventivo')"
          v-if="editingControlPreventivo"
        >{{$t('Guardar')}}</el-button>
        <el-button
          type="primary"
          @click="addControlPreventivo('formControlPreventivo')"
          v-else
        >{{$t('Agregar')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Impacto')"
      :rules="rules"
      append-to-body
      ref="formImpacto"
      :visible="dialogNewImpactoVisible"
    >
      <h4 v-if="risk.tipo === 'medioambiente'">{{$t('DESCRIPCIÓN DEL IMPACTO')}}</h4>
      <el-row v-if="risk.tipo === 'medioambiente'">
        <el-col :sm="24">
          <el-input
            type="textarea"
            :rows="3"
            placeholder="Ingrese descripción del impacto"
            v-model="formImpacto.descripcion"
          ></el-input>
        </el-col>
      </el-row>
      <br v-if="risk.tipo === 'medioambiente'" />
      <h4>{{$t('SELECCIONE VALORES')}}</h4>
      <el-row>
        <el-col :sm="8">
          <el-button
            @click="dialogSeleccionSeveridadVisible = true"
          >{{$t('Seleccione Nivel Severidad Residual')}}</el-button>
        </el-col>
      </el-row>
      <br />
      <h4>{{$t('INFORMACIÓN')}}</h4>
      <el-row>
        <el-col :sm="12">
          <label>{{$t('Categoría Impacto')}}</label>
          <p class="info-txt" v-if="formImpacto.categoria">{{formImpacto.categoria}}</p>
          <p class="info-txt" v-else>---</p>
        </el-col>
        <el-col :sm="12">
          <label>{{$t('Nivel Severidad Residual')}}</label>
          <p class="info-txt" v-if="formImpacto.nivel_severidad">{{formImpacto.nivel_severidad}}</p>
          <p class="info-txt" v-else>---</p>
        </el-col>
        <el-col :sm="12">
          <label>{{$t('Nivel Severidad MFL')}}</label>
          <p class="info-txt" v-if="formImpacto.mfl">{{formImpacto.mfl}}</p>
          <p class="info-txt" v-else>---</p>
        </el-col>
        <el-col :sm="12">
          <label>{{$t('Tipo de impacto')}}</label>
          <p class="info-txt" v-if="formImpacto.tipo">{{formImpacto.tipo}}</p>
          <p class="info-txt" v-else>---</p>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogImpacto()">{{$t('Cancelar')}}</el-button>
        <el-button
          type="primary"
          @click="editImpacto('formImpacto')"
          v-if="editingImpacto"
        >{{$t('Guardar')}}</el-button>
        <el-button type="primary" @click="addImpacto('formImpacto')" v-else>{{$t('Agregar')}}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      top="15px"
      width="90%"
      :before-close="handleClose"
      :title="$t('Seleccione Nivel de Severidad')"
      append-to-body
      :visible="dialogSeleccionSeveridadVisible"
    >
      <p>{{ $t('Seleccione el "Nivel de Severidad Residual (NSR)" haciendo click sobre alguna de las descripciones que salen dentro de la Tabla. Esta selección resultará en obtener el "Nivel de Severidad" y el "Factor de Severidad". Tener en cuenta que el NSR debe ser menor al MFL (Máxima Pérdida Previsible).') }}</p>
      <TablaSeveridad :click="seleccionaImpacto" :impactType="risk.tipo" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSeleccionSeveridadVisible = false">{{ $t('Cancelar') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      top="15px"
      width="90%"
      :before-close="handleClose"
      :title="$t('Seleccione Nivel de Severidad')"
      append-to-body
      :visible="dialogSetSeveridadSinControles"
    >
      <p>{{ $t('Seleccione el "Nivel de Severidad Residual (NSR)" haciendo click sobre alguna de las descripciones que salen dentro de la Tabla. Esta selección resultará en obtener el "Nivel de Severidad" y el "Factor de Severidad". Tener en cuenta que el NSR debe ser menor al MFL (Máxima Pérdida Previsible).') }}</p>
      <TablaSeleccionSeveridad :click="setImpactoSinImpacto" :impactType="risk.tipo" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSetSeveridadSinControles = false">{{ $t('Cancelar') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      top="15px"
      width="90%"
      :before-close="handleClose"
      :title="$t('Seleccione Nivel de Severidad')"
      append-to-body
      :visible="dialogSetSeveridadConControles"
    >
      <p>{{ $t('Seleccione el "Nivel de Severidad Residual (NSR)" haciendo click sobre alguna de las descripciones que salen dentro de la Tabla. Esta selección resultará en obtener el "Nivel de Severidad" y el "Factor de Severidad". Tener en cuenta que el NSR debe ser menor al MFL (Máxima Pérdida Previsible).') }}</p>
      <TablaSeleccionSeveridad :click="setImpactoConImpacto" :impactType="risk.tipo" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSetSeveridadConControles = false">{{ $t('Cancelar') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="42%"
      :before-close="handleClose"
      :title="$t('Seleccione Factor de Probabilidad')"
      append-to-body
      :visible="dialogSeleccionProbabilidadVisible"
    >
      <p>
        {{$t('Seleccione el "Factor de Probabilidad" haciendo click sobre alguna de las descripciones que salen dentro de la tabla.')}}
        <br />
        {{$t('Esta selección resultará en obtener el "Factor de Probabilidad".')}}
      </p>
      <TablaProbabilidad :click="seleccionaProbabilidad" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSeleccionProbabilidadVisible = false">{{ $t('Cancelar') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="42%"
      :before-close="handleClose"
      :title="$t('Seleccione Factor de Probabilidad')"
      append-to-body
      :visible="dialogSetProbabilidadSinControles"
    >
      <p>
        {{$t('Seleccione el "Factor de Probabilidad" haciendo click sobre alguna de las descripciones que salen dentro de la tabla.')}}
        <br />
        {{$t('Esta selección resultará en obtener el "Factor de Probabilidad".')}}
      </p>
      <TablaProbabilidad :click="setProbabilidadSinImpacto" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSetProbabilidadSinControles = false">{{ $t('Cancelar') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      width="42%"
      :before-close="handleClose"
      :title="$t('Seleccione Factor de Probabilidad')"
      append-to-body
      :visible="dialogSetProbabilidadConControles"
    >
      <p>
        {{$t('Seleccione el "Factor de Probabilidad" haciendo click sobre alguna de las descripciones que salen dentro de la tabla.')}}
        <br />
        {{$t('Esta selección resultará en obtener el "Factor de Probabilidad".')}}
      </p>
      <TablaProbabilidad :click="setProbabilidadConImpacto" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSetProbabilidadConControles = false">{{ $t('Cancelar') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      top="15px"
      width="90%"
      :before-close="handleClose"
      :title="$t('Seleccione MFL')"
      append-to-body
      :visible="dialogSeleccionMFLVisible"
    >
      <p>{{ $t('Seleccione el "Nivel de Severidad MFL (Máxima Pérdida Previsible)." haciendo click sobre alguna de las descripciones que salen dentro de la tabla. Esta selección resultará en obtener el "Nivel de Severidad MFL". Tener en cuenta que el MFL debe ser mayor a NSR.') }}</p>
      <TablaSeveridad :click="seleccionaMFL" :impactType="risk.tipo" />
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogSeleccionMFLVisible = false">{{ $t('Cancelar') }}</el-button>
      </span>
    </el-dialog>

    <el-dialog
      :before-close="handleClose"
      :title="$t('Control Mitigador')"
      append-to-body
      :rules="rules"
      ref="formControlMitigador"
      :visible="dialogNewControlMitigadorVisible"
    >
      <el-form :model="formControlMitigador" label-position="top">
        <el-form-item :label="$t('Impacto')" prop="impacto" :label-width="formLabelWidth">
          <el-select
            style="width: 750px;"
            v-model="formControlMitigador.impacto"
            filterable
            class="with-help-box"
            :placeholder="$t('Seleccione impacto asociado')"
          >
            <el-option
              v-for="(impacto, index) in risk.impactos"
              :key="index"
              :label="impacto.tipo"
              :value="impacto.id"
            />
          </el-select>
          <el-button
            @click="dialogNewImpactoVisible = true"
            style="margin-left: 10px;"
            type="primary"
            size="medium"
          >Añadir Impactos</el-button>
        </el-form-item>
        <el-form-item :label="$t('Nombre')" prop="nombre" :label-width="formLabelWidth">
          <el-input class="with-help-box" v-model="formControlMitigador.nombre" auto-complete="on" />
        </el-form-item>
        <el-form-item
          :label="$t('Responsable del Control Mitigador')"
          :label-width="formLabelWidth"
        >
          <el-input
            class="with-help-box"
            v-model="formControlMitigador.responsable"
            auto-complete="on"
          />
        </el-form-item>
        <el-form-item :label="$t(`Frecuencia`)" :label-width="formLabelWidth">
          <el-select
            v-model="formControlMitigador.frecuencia"
            filterable
            class="with-help-box full-width"
            :placeholder="$t(`Seleccione una frecuencia`)"
          >
            <el-option
              v-for="item in frecuencias"
              :key="item.value"
              :label="item.value"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('Elemento de soporte al control')"
          prop="elementoSoporte"
          :label-width="formLabelWidth"
        >
          <el-input class="with-help-box" v-model="formControlMitigador.elemento_soporte" />
        </el-form-item>
        <el-form-item
          :label="$t(`Jerarquía de control`)"
          prop="jerarquia"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="formControlMitigador.jerarquiaControl"
            filterable
            class="with-help-box full-width"
            :placeholder="$t(`Seleccione Jerarquía de control`)"
          >
            <el-option
              v-for="jerarquia in jerarquiaControl"
              :key="jerarquia.value"
              :label="jerarquia.value"
              :value="jerarquia.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('¿Es control crítico?')"
          prop="critico"
          :label-width="formLabelWidth"
        >
          <el-switch
            class="with-help-box"
            v-model="formControlPreventivo.critico"
            active-text="Sí"
            inactive-text="No"
          />
          <el-popover
            class="help-box"
            placement="right"
            :title="$t('Control Crítico')"
            width="400"
            trigger="hover"
          >
            {{ $t(`Son quellos controles que solo o en conjunto con otros
            controles reduce significativamente la probabilidad
            y/o el impacto de los riesgos materiales.`) }}
            <br />
            {{ $t(`Puede haber más de un control crítico para un riesgo material.`) }}
            <br />
            {{ $t(`Elementos a considerar en la determinación de un control crítico:`) }}
            <ul>
              <li>
                {{ $t(`Única barrera/capa de protección disponible para la ocurrencia
                del evento o la exposición al impacto.`) }}
              </li>
              <li>{{ $t(`Se utiliza para prevenir o mitigar múltiples causas/impactos.`) }}</li>
              <li>{{ $t(`Es independiente de otros controles.`) }}</li>
              <li>
                {{ $t(`El control es más alto en la jerarquía de controles que
                otros controles en consideración.`) }}
              </li>
              <li>{{ $t(`Se utiliza para detectar o prevenir que el evento escale.`) }}</li>
            </ul>
            <i slot="reference" class="el-icon-question"></i>
          </el-popover>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialogControlMitigador()">Cancelar</el-button>
        <el-button
          v-if="editingControlMitigador"
          type="primary"
          @click="editControlMitigador('formControlMitigador')"
        >{{ $t('Guardar') }}</el-button>
        <el-button
          v-else
          type="primary"
          @click="addControlMitigador('formControlMitigador')"
        >{{ $t('Agregar') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { clone } from "lodash";
import uuid from "uuid/v4";
import Vue from "vue";
import TablaSeveridad from "./TablaSeveridad.vue";
import TablaSeleccionSeveridad from "./TablaSeveridad.vue";
import TablaProbabilidad from "./TablaProbabilidad.vue";
import axios from "axios";

export default {
  components: {
    TablaSeveridad,
    TablaProbabilidad,
    TablaSeleccionSeveridad
  },
  data() {
    return {
      dialogFecha: false,
      dialogResponsable: false,
      dialogControlesAdicionales: false,
      dialogEventoNoDeseado: false,
      dialogEventoTop: false,
      dialogPeligro: false,
      dialogEnergia: false,
      dialogTypeControl: false,
      dialogEditKRI: false,
      dialogAddKRI: false,
      kri: {
        id: "",
        descripcion: "",
        valor: ""
      },
      dialogSetProbabilidadConControles: false,
      dialogSetSeveridadConControles: false,
      dialogSetProbabilidadSinControles: false,
      dialogSetSeveridadSinControles: false,
      ir_sin_controles: "",
      count: 0,
      searchUser: false,
      inputCargoDisable: true,
      inputNombreDisable: true,
      componentKey: 0,
      dialogNewEvaluadorVisible: false,
      dialogNewCausaVisible: false,
      dialogNewImpactoVisible: false,
      dialogNewControlPreventivoVisible: false,
      dialogNewControlMitigadorVisible: false,
      dialogSeleccionSeveridadVisible: false,
      dialogSeleccionProbabilidadVisible: false,
      dialogSeleccionMFLVisible: false,
      standard_risks: [],
      standard_risks_original: [],
      standard_risk_message: "",
      standard_risk_found: false,
      standardRiskButtonEnabled: false,
      noStandardRiskLeft: false,
      srrLoading: false,
      srrChecked: false,
      waitingForStandardRisk: true,
      formCustomRisk: {
        nombre: null,
        tipo: null,
        standardRisk: null
      },
      frecuencias: [
        { value: "Diario" },
        { value: "Semanal" },
        { value: "Mensual" },
        { value: "Anual" }
      ],
      jerarquiaControl: [
        {
          value: "Eliminar"
        },
        {
          value: "Sustituir"
        },
        {
          value: "Rediseño"
        },
        {
          value: "Aislar / Separar"
        },
        {
          value: "Administración / Auditorias / Capacitación"
        },
        {
          value: "Equipo de Protección Personal"
        },
        {
          value: "Conducta"
        }
      ],
      causasInmediatas: [
        {
          label: "Salud y Seguridad",
          options: [
            { value: "Acción de terceros" },
            { value: "Actuar sin autorización" },
            { value: "Actuar a velocidad anormal" },
            { value: "Conducta / comportamiento inadecuado" },
            { value: "Desviarse de los Métodos /normativas aceptadas" },
            { value: "Intervenir equipos energizados y/o en movimientos" },
            { value: "Mal manejo de materiales, equipos e insumos" },
            { value: "No advertir /señalizar" },
            { value: "No usar equipo de protección personal" },
            { value: "Omitir o neutralizar dispositivos de protección" },
            { value: "Presentarse en condiciones anormales" },
            { value: "Ubicarse en posición o postura incómoda" },
            { value: "Uso de vestuario o elementos extraños" },
            { value: "Uso inadecuado de datos /información" },
            { value: "Uso inadecuado de herramientas y equipos de protección" },
            { value: "Almacenamiento defectuoso" },
            { value: "Área/ Recinto congestionado o restringido" },
            { value: "Equipo de protección fuera de especificación" },
            {
              value:
                "Factores/ condiciones ambientales anormales (Exposiciones al ruido, radiación, falta ventilación / iluminación o temperaturas extremas)"
            },
            { value: "Falta o falla de protecciones / defensas" },
            {
              value: "Herramientas / materiales / equipos defectuoso o inapropiado"
            },
            { value: "Identificación y señalización incorrectas" },
            { value: "Método o Procedimiento Peligroso" },
            { value: "Orden y aseo deficientes" },
            { value: "Problemas en sistemas de energías" },
            { value: "Protección y defensas fuera de norma o especificación" },
            { value: "Sistemas de información deficiente" },
            {
              value: "Sobrecarga /saturación de sistemas /instalaciones / equipos"
            },
            { value: "Superficie de trabajo dañada / inadecuada" },
            { value: "Vehículo / equipo en mal estado" },
            { value: "Peligro de explosión o incendio" }
          ]
        },
        {
          label: "Medioambiente",
          options: [
            {
              value: "Ausencia de controles"
            },
            {
              value: "Falla de los controles"
            },
            {
              value: "No aplicación de los controles (fisicos)"
            },
            {
              value: "Falla de Materiales"
            },
            {
              value: "Accion de terceros"
            },
            {
              value: "No aplicación de procedimiento"
            },
            {
              value: "Almacenamiento defectuoso"
            },
            {
              value: "aplicación inadecuada de controles"
            },
            {
              value: "Desconocimiento de procedimiento"
            },
            {
              value: "Diseño inadecuado del control"
            },
            {
              value: "actividad no autorizada"
            },
            {
              value: "extraccion  sobre lo autorizado"
            },
            {
              value: "Falta de seguimiento al control "
            },
            {
              value: "Daño por equipo móvil"
            }
          ]
        },
        {
          label: "Otro",
          options: [
            {
              label: "Otro",
              value: "other"
            }
          ]
        }
      ],
      editingCausa: false,
      editingCausaID: null,
      formCausa: {
        nombre: "",
        nombreTemp: ""
      },
      editingControlPreventivo: false,
      editingControlPreventivoID: null,
      formControlPreventivo: {
        nombre: "",
        critico: false,
        jerarquiaControl: "",
        frecuencia: "",
        responsable: "",
        causas: [],
        elemento_soporte: ""
      },
      editingImpacto: false,
      editingImpactoID: null,
      formImpacto: {
        categoria: "",
        tipo: "",
        descripcion: "",
        nivel_severidad: "",
        mfl: ""
      },
      editingControlMitigador: false,
      editingControlMitigadorID: null,
      formControlMitigador: {
        nombre: "",
        critico: false,
        jerarquiaControl: "",
        responsable: "",
        frecuencia: "",
        impacto: "",
        elemento_soporte: ""
      },
      editingEvaluador: false,
      editingEvaluadorID: null,
      formEvaluador: {
        id: "",
        nombre: "",
        rut: "",
        cargo: "",
        frecuencia: ""
      },
      formLabelWidth: "150px",
      optionsCondicion: [{ value: "Normal" }, { value: "Anormal" }, { value: "Emergencia" }],
      rules: {
        nombre: [
          {
            required: true,
            message: "Please input Activity name",
            trigger: "blur"
          },
          {
            min: 3,
            max: 5,
            message: "Length should be 3 to 5",
            trigger: "blur"
          }
        ]
      },
      rulesEvaluador: {
        rut: [
          {
            required: true,
            message: "Por favor ingrese RUT",
            trigger: "change"
          }
        ],
        nombre: [
          {
            required: true,
            message: "Por favor ingrese Nombre",
            trigger: "change"
          }
        ]
      }
    };
  },
  computed: {
    causasInmediatasComputed() {
      const selected = this.risk.causas.map(r => r.nombre);
      let options = [];
      this.causasInmediatas.forEach(ci => {
        let group = { label: ci.label, options: [] };
        ci.options.forEach(o => {
          if (!selected.includes(o.value)) {
            group.options.push(o);
          } else {
          }
        });
        options.push(group);
      });
      return options;
    }
  },
  props: [
    "taskName",
    "editRisk",
    "saveChange",
    "action",
    "onAcept",
    "onClose",
    "visibleSync",
    "editable",
    "risk",
    "appendToBody",
    "allStandardRisks",
    "riskItem",
    "closeDialogCustomRisk"
  ],
  watch: {
    "formEvaluador.rut": function() {
      this.debounceInput();
    }
  },
  methods: {
    getColors(p, s) {
      /* QUINTA */
      if (p === 1 && s === 1) {
        return "green";
      }
      if (p === 2 && s === 1) {
        return "green";
      }
      if (p === 3 && s === 1) {
        return "green";
      }
      if (p === 4 && s === 1) {
        return "yellow";
      }
      if (p === 5 && s === 1) {
        return "yellow";
      }
      /* CUARTA */
      if (p === 1 && s === 2) {
        return "green";
      }
      if (p === 2 && s === 2) {
        return "green";
      }
      if (p === 3 && s === 2) {
        return "yellow";
      }
      if (p === 4 && s === 2) {
        return "yellow";
      }
      if (p === 5 && s === 2) {
        return "orange";
      }
      /* TERCERA */
      if (p === 1 && s === 3) {
        return "yellow";
      }
      if (p === 2 && s === 3) {
        return "yellow";
      }
      if (p === 3 && s === 3) {
        return "orange";
      }
      if (p === 4 && s === 3) {
        return "orange";
      }
      if (p === 5 && s === 3) {
        return "red";
      }
      /* SEGUNDA */
      if (p === 1 && s === 4) {
        return "yellow";
      }
      if (p === 2 && s === 4) {
        return "orange";
      }
      if (p === 3 && s === 4) {
        return "orange";
      }
      if (p === 4 && s === 4) {
        return "red";
      }
      if (p === 5 && s === 4) {
        return "red";
      }
      /* PRIMERA */
      if (p === 1 && s === 5) {
        return "orange";
      }
      if (p === 2 && s === 5) {
        return "orange";
      }
      if (p === 3 && s === 5) {
        return "red";
      }
      if (p === 4 && s === 5) {
        return "red";
      }
      if (p === 5 && s === 5) {
        return "red";
      }
    },
    closeDialogWrac() {
      this.dialogPeligro = false;
      this.dialogEnergia = false;
      this.dialogEventoTop = false;
      this.dialogEventoNoDeseado = false;
      this.dialogControlesAdicionales = false;
      this.dialogResponsable = false;
      this.dialogFecha = false;
    },
    editKRI() {
      const index = this.risk.kri.findIndex(data => data.id === this.kri.id);
      if (index !== -1) {
        this.risk.kri[index] = this.kri;
      }
      this.handleClose();
      this.forceRerender();
    },
    editDialogKRI(kri) {
      this.kri = JSON.parse(JSON.stringify(kri));
      this.dialogEditKRI = true;
    },
    deleteDialogKRI(index) {
      this.$confirm(
        this.$t("Esto borrará el KRI Establecido seleccionado. ¿Está seguro que desea continuar?"),
        this.$t("Atención"),
        {
          type: "warning"
        }
      ).then(() => {
        this.risk.kri.splice(index, 1);
      });
    },
    addKRI() {
      if (!this.risk.kri) {
        this.risk.kri = [];
      }
      (this.kri.id = uuid()), this.risk.kri.push(this.kri);
      this.handleClose();
    },
    openDialogKRI() {
      this.dialogAddKRI = true;
    },
    rejectStandardRiskAdvice() {
      this.waitingForStandardRisk = false;
      this.standard_risk_found = false;
    },
    showStandardRisk() {
      var self = this;
      const filtering = this.$store.getters.role.faena_id;
      this.formCustomRisk.nombre = filtering;
      this.srrLoading = true;
      axios
        .get(
          `https://srr.inventarios.dev.bhp.lifeon.cl/standard_risk/${
            this.risk.nombre
          }/?job=${filtering}`
        )
        .then(response => {
          self.srrChecked = true;
          const standardRiskBackUp = response.data.slice(0);
          const selectedRisks =
            self.$store.getters.inventario.tareas[self.$store.getters.selectedIndexTask].riesgos;
          if (selectedRisks !== undefined) {
            for (let i = 0; i < selectedRisks.length; i++) {
              for (let j = 0; j < response.data.length; j++) {
                if (response.data[j].id === selectedRisks[i]._id) {
                  response.data.splice(j, 1);
                  break;
                }
              }
            }
          }
          self.standard_risks = response.data;
          self.standard_risk_found = true;

          if (self.standard_risks.length > 0) {
            self.standard_risk_message =
              "El riesgo que está ingresando puede estar asociado a los siguientes Riesgos Transversales. " +
              "Para continuar debe seleccionar alguno de los siguientes Riesgos Transversales para agregarlos como tal";
          } else if (standardRiskBackUp.length !== response.data.length) {
            self.standard_risk_message =
              "El riesgo que está ingresando puede estar asociado a alguno de los siguientes " +
              "Riesgos Transversales que ya tiene agregado:";
            self.standard_risks_original = standardRiskBackUp;
            self.noStandardRiskLeft = true;
          } else {
            self.rejectStandardRiskAdvice();
          }
          self.srrLoading = false;
        })
        .catch(error => {
          self.$message({
            type: "warning",
            message: "problema al tratar de encontrar riesgo"
          });
          self.srrLoading = false;
          self.srrChecked = true;
          self.rejectStandardRiskAdvice();
        });
      return null;
    },
    addCustomRiskSRR() {
      for (let i = 0; i < this.allStandardRisks.length; i++) {
        if (this.formCustomRisk.standardRisk === this.allStandardRisks[i]._id) {
          this.$store.dispatch("addRisk", this.allStandardRisks[i]);
          this.$notify.info({
            duration: 3000,
            title: "Atención",
            message: "Riesgos Transversales se agregaron exitosamente"
          });
          this.saveChange();
        }
      }
      if (this.closeDialogCustomRisk) this.closeDialogCustomRisk();
      this.srrLoading = false;
    },
    enableStandardRiskButton() {
      this.standardRiskButtonEnabled = true;
    },
    searchStandardRisk: _.debounce(function() {
      this.showStandardRisk();
    }, 1000),
    debounceInput: _.debounce(function() {
      this.searchUser = true;
      const userExist = this.$store.getters.usersFaena.find(x => x.rut === this.formEvaluador.rut);
      if (userExist) {
        this.formEvaluador = {
          id: userExist._id,
          nombre: `${userExist.nombre} ${userExist.apellido}`,
          rut: userExist.rut
        };
        this.inputNombreDisable = true;
        this.inputCargoDisable = false;
        this.searchUser = false;
      } else {
        axios
          .get(`/usuarios/by_rut/${this.formEvaluador.rut}`, {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`
            }
          })
          .then(response => {
            if (response.data.success !== false) {
              this.formEvaluador.id = response.data._id;
              this.formEvaluador.nombre = `${response.data.nombre} ${response.data.apellido}`;
              this.formEvaluador.rut = response.data.rut;
              this.inputNombreDisable = true;
              this.inputCargoDisable = false;
              this.searchUser = false;
            } else {
              this.inputNombreDisable = false;
              this.inputCargoDisable = false;
              this.formEvaluador.id = "";
              /* this.formEvaluador.nombre = '';
            this.formEvaluador.cargo = ''; */
              this.searchUser = false;
            }
          });
      }
    }, 1500),
    validarControlMitigador(impacto) {
      let visible = false;
      impacto.forEach(imp => {
        if (imp.controles_mitigadores && imp.controles_mitigadores.length > 0) {
          imp.controles_mitigadores.forEach(mitigador => {
            if (mitigador.not_apply === true) {
              visible = false;
            } else {
              visible = true;
            }
          });
        } else {
          visible = true;
        }
      });
      return visible;
    },
    setTypeRisk(typeRisk) {
      if (this.risk.tipo === null || this.risk.impactos.length === 0) {
        this.changeType(typeRisk);
      } else {
        this.$confirm(
          "Al cambiar el tipo de impacto se reestablecerá la evaluación del impacto y los riesgos mitigadores ya definidos. ¿Seguro deseas continuar?",
          "Advertencia",
          {
            confirmButtonText: "Continuar",
            cancelButtonText: "Cancelar",
            type: "warning"
          }
        )
          .then(() => {
            this.changeType(typeRisk);
            this.risk.impactos = [];
            // this.risk.causas = [];
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "Acción cancelada"
            });
          });
      }
    },
    changeType(typeRisk) {
      this.risk.tipo = typeRisk;
      this.risk.salud = typeRisk === "salud";
      this.risk.seguridad = typeRisk === "seguridad";
      if (typeRisk === "medioambiente") {
        this.risk.medioambiental = true;
        this.risk.medioambiente = {};
      } else {
        this.risk.medioambiental = false;
        this.risk.medioambiente = {};
      }
    },
    handleClose() {
      this.kri = {
        id: "",
        descripcion: "",
        valor: ""
      };
      this.dialogAddKRI = false;
      this.dialogEditKRI = false;
      this.dialogNewEvaluadorVisible = false;
      this.dialogNewCausaVisible = false;
      this.dialogNewImpactoVisible = false;
      this.dialogNewControlPreventivoVisible = false;
      this.dialogNewControlMitigadorVisible = false;
      this.dialogSeleccionSeveridadVisible = false;
      this.dialogSeleccionProbabilidadVisible = false;
      this.dialogSeleccionMFLVisible = false;
      this.dialogSetSeveridadSinControles = false;
      this.dialogSetProbabilidadSinControles = false;
      this.dialogSetSeveridadConControles = false;
    },
    getControlesPreventivos(risk) {
      const controlesIndicator = {};
      if (risk.causas) {
        risk.causas.forEach((causa, index) => {
          const humanID = `CA${index + 1}`;
          if (causa.controles_preventivos) {
            causa.controles_preventivos.forEach(control => {
              if (!controlesIndicator[control.nombre]) {
                controlesIndicator[control.nombre] = {};
                controlesIndicator[control.nombre].critico = control.critico;
                controlesIndicator[control.nombre].id = control.id;
                controlesIndicator[control.nombre].jerarquiaControl = control.jerarquiaControl;
                controlesIndicator[control.nombre].responsable = control.responsable;
                controlesIndicator[control.nombre].frecuencia = control.frecuencia;
                controlesIndicator[control.nombre].elemento_soporte = control.elemento_soporte;
              }
              if (!controlesIndicator[control.nombre].causasHumanID) {
                controlesIndicator[control.nombre].causasHumanID = [];
                controlesIndicator[control.nombre].causasID = [];
              }
              controlesIndicator[control.nombre].causasHumanID.push(humanID);
              controlesIndicator[control.nombre].causasID.push(causa.id);
            });
          }
        });
      }
      const controles = Object.keys(controlesIndicator).map(key => ({
        tipo: "Control Preventivo",
        causasHumanID: controlesIndicator[key].causasHumanID,
        causasID: controlesIndicator[key].causasID,
        nombre: key,
        critico: controlesIndicator[key].critico,
        id: controlesIndicator[key].id,
        jerarquiaControl: controlesIndicator[key].jerarquiaControl,
        responsable: controlesIndicator[key].responsable,
        frecuencia: controlesIndicator[key].frecuencia,
        elemento_soporte: controlesIndicator[key].elemento_soporte
      }));
      return controles;
    },
    getControlesMitigadores(risk) {
      const controles = [];
      if (risk.impactos) {
        risk.impactos.forEach((impacto, index) => {
          const id = `IM${index + 1}`;
          if (impacto.controles_mitigadores) {
            impacto.controles_mitigadores.forEach(control => {
              (control.tipo = "Control Mitigador"), (control.id_impacto = id);
              control.impactoId = impacto.id;
              controles.push(control);
            });
          }
        });
      }
      return controles;
    },
    getFactores(risk) {
      let mfl = 0;
      let rrr = 0;
      if (risk.impactos) {
        risk.impactos.forEach(impacto => {
          if (impacto.mfl > mfl) {
            ({ mfl } = impacto);
            rrr = (impacto.factor_severidad * 10 * (impacto.factor_probabilidad * 10)) / (10 * 10);
          }
        });
      }
      return [
        {
          mfl,
          rrr
        }
      ];
    },
    mflRange(mfl) {
      if (mfl >= 4) {
        return "danger";
      }
      if (mfl === 3) {
        return "warning";
      }
      return "gray";
    },
    tablaControlCritico(row, index) {
      if (row.critico) {
        return "control-critico";
      }
    },
    addCausa(formName) {
      let causa = this.formCausa.nombre;
      if (this.formCausa.nombreTemp !== "other") {
        causa = this.formCausa.nombreTemp;
      }
      if (!causa) {
        this.$message({
          message: this.$t("Debes seleccionar o escribir una causa"),
          type: "error"
        });
        return;
      }

      this.risk.causas.push({ id: uuid(), nombre: causa });

      this.closeDialogCausa();
    },
    closeDialogCausa() {
      this.editingCausa = false;
      this.editingCausaID = null;
      this.formCausa.nombre = "";
      this.formCausa.nombreTemp = "";
      this.dialogNewCausaVisible = false;
      this.dialogTypeControl = false;
    },
    addImpacto(formName) {
      if (this.formImpacto.mfl) {
        const impacto = {
          id: uuid(),
          tipo: this.formImpacto.tipo,
          descripcion: this.formImpacto.descripcion,
          categoria: this.formImpacto.categoria,
          nivel_severidad: this.formImpacto.nivel_severidad,
          mfl: this.formImpacto.mfl,
          controles_mitigadores: []
        };
        this.risk.impactos.push(impacto);
      }
      this.closeDialogImpacto();
    },
    closeDialogImpacto() {
      this.editingImpacto = false;
      this.editingImpactoID = null;
      this.formImpacto.nivel_severidad = "";
      this.formImpacto.factor_probabilidad = "";
      this.formImpacto.categoria = "";
      this.formImpacto.descripcion = "";
      this.formImpacto.mfl = "";
      this.formImpacto.comentario = "";
      this.formImpacto.tipo = "";
      this.dialogNewImpactoVisible = false;
    },
    setImpactoSinImpacto(impacto, tipo, descripcion) {
      this.risk.sin_controles.severidad = impacto.nivelSeveridad;
      this.dialogSetSeveridadSinControles = false;
    },
    setImpactoConImpacto(impacto, tipo, descripcion) {
      this.risk.con_controles.severidad = impacto.nivelSeveridad;
      this.dialogSetSeveridadConControles = false;
    },
    seleccionaImpacto(impacto, tipo, descripcion) {
      this.formImpacto.tipo = tipo;
      this.formImpacto.descripcion = descripcion;
      this.formImpacto.nivel_severidad = impacto.nivelSeveridad;
      this.formImpacto.mfl = impacto.nivelSeveridad;
      // Setear severidad por tipo de impacto
      if (this.risk.tipo === "salud") {
        this.formImpacto.categoria = "Salud";
      } else if (this.risk.tipo === "seguridad") {
        this.formImpacto.categoria = "Seguridad";
      } else if (this.risk.tipo === "medioambiental" || this.risk.tipo === "medioambiente") {
        this.formImpacto.categoria = "Medioambiente";
      }
      this.dialogSeleccionSeveridadVisible = false;
    },
    seleccionaMFL(impacto, tipo) {
      if (this.formImpacto.nivel_severidad) {
        if (impacto.nivelSeveridad < this.formImpacto.nivel_severidad) {
          this.$alert(
            `${this.$t("Tu MFL debe ser mayor o igual al Nivel de Severidad Residual")} (${
              this.formImpacto.nivel_severidad
            })`,
            this.$t("Atención"),
            { type: "error" }
          );
          return;
        } else if (impacto.nivelSeveridad === this.formImpacto.nivel_severidad) {
          this.$prompt(
            "Atención MFL y Nivel de severidad son iguales, debido a esto debe ingresar un comentario explicando las razones.",
            "Ingrese comentario",
            {
              confirmButtonText: "Aceptar",
              cancelButtonText: "Cancelar",
              inputType: "textarea",
              inputErrorMessage: "Comentario invalido"
            }
          ).then(({ value }) => {
            this.$message({
              type: "success",
              message: "Comentario ingresado con exito"
            });
            this.formImpacto.comentario = value;
            this.formImpacto.mfl = impacto.nivelSeveridad;
            this.dialogSeleccionMFLVisible = false;
          });
          return;
        }
      }
      this.formImpacto.comentario = "";
      this.formImpacto.mfl = impacto.nivelSeveridad;
      this.dialogSeleccionMFLVisible = false;
    },
    seleccionaProbabilidad(probabilidad) {
      this.formImpacto.factor_probabilidad = probabilidad;
      this.dialogSeleccionProbabilidadVisible = false;
    },
    setProbabilidadSinImpacto(probabilidad) {
      this.risk.sin_controles.probabilidad = probabilidad;
      this.dialogSetProbabilidadSinControles = false;
    },
    setProbabilidadConImpacto(probabilidad) {
      this.risk.con_controles.probabilidad = probabilidad;
      this.dialogSetProbabilidadConControles = false;
    },
    addControlPreventivo(formName) {
      const control = clone(this.formControlPreventivo);
      if (control.nombre && control.causas.length > 0) {
        const controlPreventivo = {
          id: uuid(),
          nombre: control.nombre,
          critico: control.critico,
          jerarquiaControl: control.jerarquiaControl,
          responsable: control.responsable,
          frecuencia: control.frecuencia,
          elemento_soporte: control.elemento_soporte
        };
        control.causas.forEach(causeId => {
          const causeIndex = this.risk.causas.findIndex(cause => cause.id === causeId);
          if (causeIndex !== -1) {
            if (!this.risk.causas[causeIndex].controles_preventivos) {
              Vue.set(this.risk.causas, causeIndex, {
                ...this.risk.causas[causeIndex],
                controles_preventivos: []
              });
            }
            this.risk.causas[causeIndex].controles_preventivos.push(controlPreventivo);
          }
        });
      }
      this.closeDialogControlPreventivo();
    },
    closeDialogControlPreventivo() {
      this.dialogTypeControl = false;
      this.editingControlPreventivo = false;
      this.editingControlPreventivoID = null;
      this.formControlPreventivo.nombre = "";
      this.formControlPreventivo.critico = false;
      this.formControlPreventivo.responsable = "";
      this.formControlPreventivo.causas = [];
      this.formControlPreventivo.jerarquiaControl = "";
      this.formControlPreventivo.elemento_soporte = "";
      this.dialogNewControlPreventivoVisible = false;
    },
    addControlMitigador(formName) {
      const control = clone(this.formControlMitigador);
      if (control.nombre && control.impacto) {
        this.risk.impactos.forEach(imp => {
          if (!imp.controles_mitigadores) {
            imp.controles_mitigadores = [];
          }
          if (imp.id === control.impacto.id || imp.id === control.impacto) {
            const controlMitigador = {
              id: uuid(),
              nombre: control.nombre,
              critico: control.critico,
              jerarquiaControl: control.jerarquiaControl,
              responsable: control.responsable,
              frecuencia: control.frecuencia,
              not_apply: false,
              elemento_soporte: control.elemento_soporte
            };
            imp.controles_mitigadores.push(controlMitigador);
          }
        });
      }
      this.closeDialogControlMitigador();
    },
    skipControlMitigador(impacto) {
      impacto.forEach(imp => {
        if (imp.controles_mitigadores && imp.controles_mitigadores.length > 0) {
          this.$confirm(
            this.$t(
              "Esto borrará todos los controles mitigadores registrados. ¿Está seguro que desea continuar?"
            ),
            this.$t("Atención"),
            {
              type: "warning"
            }
          ).then(() => {
            this.risk.impactos.forEach(imp => {
              imp.controles_mitigadores = [];
            });
            this.addSkipControlMitigador();
          });
        } else {
          this.addSkipControlMitigador();
        }
      });
    },
    addSkipControlMitigador() {
      this.risk.impactos.forEach(imp => {
        const impactIndex = this.risk.impactos.findIndex(impact => impact.id === imp.id);
        if (impactIndex !== -1) {
          if (!this.risk.impactos[impactIndex].controles_mitigadores) {
            Vue.set(this.risk.impactos, impactIndex, {
              ...this.risk.impactos[impactIndex],
              controles_mitigadores: []
            });
          }
          const controlMitigador = {
            id: uuid(),
            nombre: "no aplica",
            critico: false,
            jerarquiaControl: "no aplica",
            responsable: "no aplica",
            not_apply: true
          };
          this.risk.impactos[impactIndex].controles_mitigadores.push(controlMitigador);
        }
      });
      this.closeDialogControlMitigador();
    },
    closeDialogControlMitigador() {
      this.editingControlMitigador = false;
      this.editingControlMitigadorID = null;
      this.formControlMitigador.nombre = "";
      this.formControlMitigador.critico = false;
      this.formControlMitigador.impacto = "";
      this.formControlMitigador.jerarquiaControl = "";
      this.formControlMitigador.responsable = "";
      this.formControlMitigador.frecuencia = "";
      this.formControlMitigador.elemento_soporte = "";
      this.dialogNewControlMitigadorVisible = false;
      this.dialogTypeControl = false;
    },
    openDialogControlMitigador() {
      this.dialogNewControlMitigadorVisible = true;
      this.formControlMitigador.impacto = "";
    },
    deleteCausa(cause) {
      this.$confirm(
        this.$t(
          "Esto borrará la causa y todos sus controles asociados. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning"
        }
      ).then(() => {
        const causeIndex = this.risk.causas.findIndex(cause => cause.id === cause.id);
        if (causeIndex >= 0) {
          Vue.delete(this.risk.causas, causeIndex);
        }
      });
    },
    deleteImpacto(impact) {
      this.$confirm(
        this.$t(
          "Esto borrará el impacto y todos sus controles asociados. ¿Está seguro que desea continuar?"
        ),
        this.$t("Atención"),
        {
          type: "warning"
        }
      ).then(() => {
        const impactIndex = this.risk.impactos.findIndex(impact => impact.id === impact.id);
        if (impactIndex >= 0) {
          Vue.delete(this.risk.impactos, impactIndex);
        }
      });
    },
    deleteControlPreventivo(control) {
      this.$confirm(
        this.$t("Esto borrará el control preventivo. ¿Está seguro que desea continuar?"),
        this.$t("Atención"),
        {
          type: "warning"
        }
      ).then(() => {
        this.risk.causas.forEach((cause, causeIndex) => {
          const controlIndex = cause.controles_preventivos.findIndex(
            control => control.id === control.id
          );
          if (controlIndex >= 0) {
            Vue.delete(this.risk.causas[causeIndex].controles_preventivos, controlIndex);
          }
        });
      });
    },
    deleteControlMitigador(control) {
      this.$confirm(
        this.$t("Esto borrará el control mitigador. ¿Está seguro que desea continuar?"),
        this.$t("Atención"),
        {
          type: "warning"
        }
      ).then(() => {
        const impactIndex = this.risk.impactos.findIndex(impact => impact.id === control.impactoId);
        if (impactIndex >= 0) {
          const impact = this.risk.impactos[impactIndex];
          const controlIndex = impact.controles_mitigadores.findIndex(
            control => control.id === control.id
          );
          if (controlIndex >= 0) {
            Vue.delete(this.risk.impactos[impactIndex].controles_mitigadores, controlIndex);
          }
        }
      });
    },
    editDialogCausa(causa) {
      this.formCausa = {
        nombre: "",
        nombreTemp: ""
      };
      let isOnList = false;
      for (const index in this.causasInmediatas) {
        for (let i = 0; i < this.causasInmediatas[index].options.length; i++) {
          const causaPredefinida = this.causasInmediatas[index].options[i]["value"];
          if (causaPredefinida === causa.nombre) {
            isOnList = true;
          }
        }
      }
      if (!isOnList) {
        this.formCausa.nombreTemp = "other";
        this.formCausa.nombre = causa.nombre;
      } else {
        this.formCausa.nombreTemp = causa.nombre;
      }
      this.editingCausa = true;
      this.editingCausaID = causa.id;
      this.dialogNewCausaVisible = true;
    },
    editCausa(formCausa) {
      let causa = this.formCausa.nombre;
      if (this.formCausa.nombreTemp !== "other") {
        causa = this.formCausa.nombreTemp;
      }
      if (!causa) {
        this.$message({
          message: this.$t("Debes seleccionar o escribir una causa"),
          type: "error"
        });
        return;
      }
      const index = this.risk.causas.findIndex(causa => causa.id === this.editingCausaID);
      if (index !== -1) {
        this.risk.causas[index].nombre = causa;
        this.forceRerender();
      }
      this.closeDialogCausa();
    },
    editDialogImpacto(impacto) {
      this.formImpacto = {
        tipo: impacto.tipo,
        categoria: impacto.categoria,
        descripcion: impacto.descripcion || "",
        comentario: impacto.comentario,
        factor_severidad: impacto.factor_severidad,
        factor_probabilidad: impacto.factor_probabilidad,
        nivel_severidad: impacto.nivel_severidad,
        mfl: impacto.mfl
      };
      this.editingImpacto = true;
      this.editingImpactoID = impacto.id;
      this.dialogNewImpactoVisible = true;
    },
    editImpacto(formImpacto) {
      // this.editImpact(this.formImpacto, this.editingImpactoID);

      const impactIndex = this.risk.impactos.findIndex(
        impact => impact.id === this.editingImpactoID
      );
      if (impactIndex >= 0) {
        Vue.set(this.risk.impactos, impactIndex, {
          ...this.risk.impactos[impactIndex],
          categoria: this.formImpacto.categoria,
          tipo: this.formImpacto.tipo,
          descripcion: this.formImpacto.descripcion,
          comentario: this.formImpacto.comentario,
          factor_probabilidad: this.formImpacto.factor_probabilidad,
          nivel_severidad: this.formImpacto.nivel_severidad,
          mfl: this.formImpacto.mfl
        });
      }
      this.closeDialogImpacto();
    },
    editDialogControlPreventivo(control) {
      this.formControlPreventivo = {
        nombre: control.nombre,
        critico: control.critico,
        causas: control.causasID,
        jerarquiaControl: control.jerarquiaControl,
        responsable: control.responsable,
        frecuencia: control.frecuencia,
        elemento_soporte: control.elemento_soporte
      };
      this.editingControlPreventivo = true;
      this.editingControlPreventivoID = control.id;
      this.dialogNewControlPreventivoVisible = true;
    },
    editControlPreventivo(formControl) {
      const control = clone(this.formControlPreventivo);
      //
      const risk = this.risk;
      risk.causas.forEach((cause, causeIndex) => {
        // Se busca si esta causa ya tiene este control asignado
        let controlIndex = -1;
        if (cause.controles_preventivos) {
          controlIndex = cause.controles_preventivos.findIndex(
            control => control.id === this.editingControlPreventivoID
          );
        }

        // El control editado, tiene asociada esta causa?
        if (control.causas.includes(cause.id)) {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            console.log(`actualiza ${cause.nombre} en ${control.nombre}`);
            Vue.set(cause.controles_preventivos, controlIndex, {
              ...cause.controles_preventivos[controlIndex],
              nombre: control.nombre,
              critico: control.critico,
              jerarquiaControl: control.jerarquiaControl,
              responsable: control.responsable,
              frecuencia: control.frecuencia,
              elemento_soporte: control.elemento_soporte
            });
          } else {
            // Agregar control a causa
            console.log(`agregando ${cause.nombre} en ${control.nombre}`);
            if (!cause.controles_preventivos) {
              cause["controles_preventivos"] = [];
            }
            const controlPreventivo = {
              id: this.editingControlPreventivoID,
              nombre: control.nombre,
              critico: control.critico,
              jerarquiaControl: control.jerarquiaControl,
              responsable: control.responsable,
              frecuencia: control.frecuencia,
              elemento_soporte: control.elemento_soporte
            };
            cause.controles_preventivos.push(controlPreventivo);
          }
          // El control editado no tiene esta causa asociada actualmente
        } else {
          // Este control ya existe en la causa?
          if (controlIndex >= 0) {
            // Entonces se borra
            console.log(`borrando ${cause.nombre} de ${control.nombre}`);
            Vue.delete(cause.controles_preventivos, controlIndex);
          }
        }
      });
      this.forceRerender();
      this.closeDialogControlPreventivo();
    },
    editDialogControlMitigador(control) {
      this.formControlMitigador = {
        nombre: control.nombre,
        critico: control.critico,
        impacto: control.impactoId,
        jerarquiaControl: control.jerarquiaControl,
        responsable: control.responsable,
        frecuencia: control.frecuencia,
        elemento_soporte: control.elemento_soporte
      };
      this.editingControlMitigador = true;
      this.editingControlMitigadorID = control.id;
      this.dialogNewControlMitigadorVisible = true;
    },
    editControlMitigador(formControl) {
      const control = clone(this.formControlMitigador);
      if (control.nombre && control.impacto) {
        this.risk.impactos.forEach((impact, impactIndex) => {
          // Se busca si este impacto ya tiene este control asignado
          let controlIndex = -1;
          if (impact.controles_mitigadores) {
            controlIndex = impact.controles_mitigadores.findIndex(
              control => control.id === this.editingControlMitigadorID
            );
          }

          // El control editado, tiene asociada este impacto?
          if (control.impacto === impact.id) {
            // Este control ya existe en el impacto?
            if (controlIndex >= 0) {
              console.log(`actualiza ${impact.categoria} en ${control.nombre}`);
              Vue.set(this.risk.impactos[impactIndex].controles_mitigadores, controlIndex, {
                ...this.risk.impactos[impactIndex].controles_mitigadores[controlIndex],
                nombre: control.nombre,
                critico: control.critico,
                jerarquiaControl: control.jerarquiaControl,
                responsable: control.responsable,
                frecuencia: control.frecuencia,
                elemento_soporte: control.elemento_soporte
              });
            } else {
              // Agregar control a impacto
              console.log(`agregando ${impact.categoria} en ${control.nombre}`);

              if (!this.risk.impactos[impactIndex].controles_mitigadores) {
                Vue.set(this.risk.impactos, impactIndex, {
                  ...this.risk.impactos[impactIndex],
                  controles_mitigadores: []
                });
              }
              const controlMitigador = {
                id: this.editingControlMitigadorID,
                nombre: control.nombre,
                critico: control.critico,
                jerarquiaControl: control.jerarquiaControl,
                responsable: control.responsable,
                frecuencia: control.frecuencia,
                elemento_soporte: control.elemento_soporte
              };
              this.risk.impactos[impactIndex].controles_mitigadores.push(controlMitigador);
            }
            // El control editado no tiene este impacto asociada actualmente
          } else {
            // Este control ya existe en el impacto?
            if (controlIndex >= 0) {
              // Entonces se borra
              console.log(`borrando ${impact.categoria} de ${control.nombre}`);
              Vue.delete(this.risk.impactos[impactIndex].controles_mitigadores, controlIndex);
            }
          }
        });
      }
      this.closeDialogControlMitigador();
    },
    closeDialogEvaluador() {
      this.editingEvaluador = false;
      this.formEvaluador = {
        nombre: null,
        cargo: null,
        rut: null,
        empresa: null,
        frecuencia: null
      };
      this.dialogNewEvaluadorVisible = false;
    },
    editDialogEvaluador(evaluador) {
      this.formEvaluador = JSON.parse(JSON.stringify(evaluador));
      this.editingEvaluador = true;
      this.dialogNewEvaluadorVisible = true;
    },
    deleteEvaluador(evaluador) {
      this.$confirm(
        this.$t("Esto borrará el evaluador. ¿Está seguro que desea continuar?"),
        this.$t("Atención"),
        {
          type: "warning"
        }
      ).then(() => {
        const evaluatorIndex = this.risk.evaluadores.findIndex(
          evaluator => evaluator.id === evaluador.id
        );
        Vue.delete(this.risk.evaluadores, evaluatorIndex);
      });
    },
    forceRerender() {
      this.componentKey += 1;
    },
    editEvaluador(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          const index = this.risk.evaluadores.findIndex(
            evaluador => evaluador.id === this.formEvaluador.id
          );
          if (index !== -1) {
            this.risk.evaluadores[index] = this.formEvaluador;
            this.forceRerender();
            this.closeDialogEvaluador();
          }
        }
        return false;
      });
    },
    addEvaluador(form) {
      this.$refs[form].validate(valid => {
        if (valid) {
          this.formEvaluador.id = uuid();
          if (this.risk.evaluadores) {
            this.risk.evaluadores.push(this.formEvaluador);
          } else {
            this.risk.evaluadores = [];
            this.risk.evaluadores.push(this.formEvaluador);
          }

          this.closeDialogEvaluador();
          return;
        }
        return false;
      });
    }
  }
};
</script>

<style scoped>
.green {
  background-color: green;
  color: white;
  font-weight: bold;
}
.yellow {
  background-color: yellow;
  font-weight: bold;
}
.orange {
  background-color: orange;
  color: white;
  font-weight: bold;
}
.red {
  background-color: red;
  color: white;
  font-weight: bold;
}
h4 {
  font-weight: bold;
}
label {
  text-transform: uppercase;
  font-weight: bold;
  color: gray;
  font-size: 11px;
}
.info-txt {
  margin-top: 5px;
  color: #e65400;
}
.factores {
  font-size: 20px;
}
.align-center {
  text-align: center;
}

.subtitle {
  color: gray !important;
}
.margin-title {
  margin-top: 0px;
}
.button-disabled {
  background-color: lightgray !important;
}
.button-skip {
  margin-left: 10px;
  width: 110px;
  border: none;
  color: white;
}

.groupLabel {
  font-size: 15px;
  font-weight: bold;
  margin-left: 19px;
}

.destacar:hover {
  background-color: red;
  color: white;
}
.wrac td {
  border: 1px solid black;
}
table td,
table td * {
  vertical-align: top;
}
</style>
